import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function organizationForRegister(iconStatus) {
  const query = `query organizationForRegister(
    $iconStatus: String
  ) {
  organizationForRegister(iconStatus: $iconStatus)  {  LimitedOrganizations{ name cageCode } 
  }
    }`;

  const variables = { iconStatus };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  if (
    response.organizationForRegister &&
    response.organizationForRegister.LimitedOrganizations
  ) {
    return response.organizationForRegister.LimitedOrganizations;
  }
  return {};
}


export async function getProcurementGroupList() {
  const query = `query getProcurementGroupList {
    getProcurementGroupList {
      procurementGroupsList {
        cage
        description
      }
    }
  }`;

  const variables = {};
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}


export async function getProcurementGroup(cage) {
  const query = `query getProcurementGroup(
    $cage: String
  ) {
    getProcurementGroup(cage: $cage)  { description cage }
    }`;

  const variables = { cage };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function addProcurementGroup(description, modifiedBy) {
  const query = `mutation addProcurementGroup(
    $description: String
    $modifiedBy: String
  ) {
    addProcurementGroup(description: $description, modifiedBy: $modifiedBy)  { description cage }
    }`;

  const variables = { description, modifiedBy };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}


// WEBPACK FOOTER //
// ./src/pages/Registration/graphql.js